export const PUBLISHED = 'Опубликовано';
